import { ApiClientEdit } from "./ApiClientEdit";
import { ApiClientsList } from "./ApiClientsList";
import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import { ApiClientCreate } from "./ApiClientCreate";

export default {
  icon: LanguageOutlinedIcon,
  list: ApiClientsList,
  create: ApiClientCreate,
  edit: ApiClientEdit,
};
